import { useEffect } from "react";
import { isEmpty } from "@/utils";

/**
 * 找到点击点是否是orderTr
 */
function findParentElDataSet(el: HTMLElement): [string?, string?] {
    let target = el;

    while (target) {
        const orderIdStr = target.parentElement?.dataset["orderId"];
        const orderIndexStr = target.parentElement?.dataset["orderIndex"];

        if (orderIdStr && !isEmpty(orderIndexStr)) {
            return [orderIdStr, orderIndexStr];
        } else {
            target = target.parentElement;
        }
    }

    return [];
}

interface ClickTdAutoToggleOrderSelectProps {
    toggleOrderSelect: (orderId: number, orderIndex: number) => void;

    refreshKey?: unknown;
}

/**
 * 实现点击td自动切换订单的选中状态
 *
 * 需要注意的点：
 *
 *  1.最外层需要使用OrderManagementStoreContext
 *  2.tr层需要带上 data-order-id data-order-index 属性
 *  3.推荐使用在
 */
export default function useClickTdAutoToggleOrderSelect(props: ClickTdAutoToggleOrderSelectProps) {
    const { toggleOrderSelect, refreshKey } = props;

    useEffect(() => {
        const orderTableEl = document.querySelector<HTMLTableElement>(".order-table");

        if (!orderTableEl) {
            return;
        }

        const handleClick = (e: Event) => {
            const el = e.target as HTMLElement;
            const dataList = findParentElDataSet(el);

            if (dataList.length === 0) return;

            const [orderIdStr, orderIndexStr] = dataList;

            const orderId = Number(orderIdStr);
            const orderIndex = Number(orderIndexStr);

            if (!orderId || Number.isNaN(orderId) || isEmpty(orderIndex) || Number.isNaN(orderIndex)) {
                return;
            }

            const tagName = el.tagName.toLowerCase();

            if (el?.className?.includes?.("ant")) return;

            let patch = false;
            if (tagName === "td") {
                /** TD中直接为文字不操作 */
                if (!el.children.length && el.innerText) {
                    patch = false;
                } else {
                    patch = true;
                }
            } else if (el.children.length >= 1) {
                patch = true;
            }

            if (patch) {
                toggleOrderSelect(orderId, orderIndex);
            }
        };

        orderTableEl.addEventListener("click", handleClick);

        return () => {
            return orderTableEl.removeEventListener("click", handleClick);
        };
    }, [toggleOrderSelect, refreshKey]);
}
